import { $apiV2 } from '../../config/api';

export const fetchOrganization = () => $apiV2.get('/team-admin/organization');
export const fetchTeamPlayers = () => $apiV2.get('/team-admin/players');
export const fetchInvitations = () => $apiV2.get('/team-admin/invitations');
// Agencies send { player_id, email }; clubs send { email } only — the player
// picks his own profile during onboarding.
export const invitePlayer = (body) => $apiV2.post('/team-admin/invite', body);
export const revokeInvitation = (id) => $apiV2.delete(`/team-admin/invitations/${id}`);
export const toggleMapping = (id) => $apiV2.post(`/team-admin/mappings/${id}/toggle`);
export const unmapPlayer = (id) => $apiV2.delete(`/team-admin/mappings/${id}`);
// Remove by user — the only way to address a club player who has not picked
// a profile yet (no mapping id exists).
export const removeMember = (userId) => $apiV2.delete(`/team-admin/members/${userId}`);
// The dedicated, role-scoped picker endpoint (was the main-platform search).
export const searchPlayerEntities = (q, limit = 20) =>
  $apiV2.get('/team-admin/search-entities', { params: { q, limit } });
